import { find } from 'lodash-es'

import { push } from '../../common/utils'

import { DONE, REOPENED, RESOLVED } from '../constants'

import {
  getBrandDefinitionBreadcrumbItemByTaskId,
  getBrandGatewayBreadcrumbItemByTaskId,
  getDishReviewBreadcrumbItemByBrandId,
  getMenuDefinitionBreadcrumbItemByTaskId,
  getMenuScrapingBreadcrumbItemByBrandId,
} from './get-breadcrumb-item-paths'

const isTaskReopened = status => status === REOPENED

const getCurrentView = ({ views, currentViewType } = {}) =>
  find(views, view => view.type === currentViewType)

const isCurrentViewDone = task => getCurrentView(task)?.status === DONE

const getBreadcrumbItemsForBrandDefinitionTaskPage = ({ relatedTasks }) => {
  const {
    brandId,
    brandGatewayTask,
    brandDefinitionTask,
    menuDefinitionTask,
  } = relatedTasks

  const items = []

  push(items, getBrandGatewayBreadcrumbItemByTaskId(brandGatewayTask))
  push(items, getBrandDefinitionBreadcrumbItemByTaskId(brandDefinitionTask))

  const brandDefinitionCurrentViewDone = isCurrentViewDone(brandDefinitionTask)

  const canShowMenuDefinition =
    menuDefinitionTask?.id &&
    (brandDefinitionTask.status === RESOLVED ||
      (isTaskReopened(brandDefinitionTask.status) &&
        brandDefinitionCurrentViewDone))

  if (!canShowMenuDefinition) return items

  push(items, getMenuDefinitionBreadcrumbItemByTaskId(menuDefinitionTask))

  if (menuDefinitionTask.status !== RESOLVED) return items

  push(items, getMenuScrapingBreadcrumbItemByBrandId(brandId))
  push(items, getDishReviewBreadcrumbItemByBrandId(brandId))

  return items
}

export default getBreadcrumbItemsForBrandDefinitionTaskPage
